jQuery(function() {
  loadHeader();
  loadCategoriesSlider();
  loadBannerSwiper();
  loadAnimations();
  loadProductCarousel();

  // Import and use the lazy loader for non-critical modules
  import(/* webpackChunkName: "lazy-loader" */ '../modules/modulesLazyLoader')
    .then(({ default: lazyLoader }) => {
      lazyLoader([
        loadHomeProducts,
        loadInstagramSlider,
        loadPreamble,
      ]);
    })
    .catch(error => console.error('Error loading lazy loader module:', error));
});

const loadHeader = () => {
  import(/* webpackChunkName: "header" */ '../modules/header/index')
    .then(({ default: header }) => {
      header();
    })
    .catch(error => console.error('Error loading header module:', error));
};

const loadCategoriesSlider = () => {
  import(/* webpackChunkName: "categories-slider" */ '../modules/categoriesSlider')
    .then(({ default: categoriesSlider }) => {
      categoriesSlider();
    })
    .catch(error => console.error('Error loading categories slider module:', error));
};

const loadBannerSwiper = () => {
  import(/* webpackChunkName: "banner-swiper" */ '../modules/initBannerSwiper')
    .then(({ default: initBannerSwiper }) => {
      initBannerSwiper();
    })
    .catch(error => console.error('Error loading banner swiper module:', error));
};

const loadAnimations = () => {
  import(/* webpackChunkName: "animations" */ '../modules/initAnimation')
    .then(({ default: initAnimations }) => {
      initAnimations();
    })
    .catch(error => console.error('Error loading animations module:', error));
};

const loadProductCarousel = () => {
  import(/* webpackChunkName: "product-carousel" */ '../modules/productCarousel')
    .then(({ default: productCarousel }) => {
      productCarousel();
    })
    .catch(error => console.error('Error loading product carousel module:', error));
};

const loadHomeProducts = () => {
  import(/* webpackChunkName: "home-products" */ '../modules/loadHomeProducts')
    .then(({ default: loadProducts }) => {
      loadProducts();
    })
    .catch(error => console.error('Error loading home products module:', error));
};

const loadInstagramSlider = () => {
  import(/* webpackChunkName: "home-instagram" */ '../modules/instagramSlider')
    .then(({ default: instagramSlider }) => {
      instagramSlider();
    })
    .catch(error => console.error('Error loading instagram slider module:', error));
};

const loadPreamble = () => {
  import(/* webpackChunkName: "home-preamble" */ '../modules/preambleOpenClose')
    .then(({ default: preambleOpenClose }) => {
      preambleOpenClose();
    })
    .catch(error => console.error('Error loading preamble module:', error));
};
